import React from 'react'

const DragIcon = ({color = 'currentColor', width = 18, height = 18, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M9.82442 6.55572V3.33075L10.527 4.02955C10.8371 4.33972 11.3043 4.33972 11.6144 4.02955C11.7714 3.8726 12.0442 3.36812 11.6144 2.9421L9.59273 0.920421C9.28257 0.610254 8.86777 0.5542 8.50528 0.920421L6.4836 2.9421C6.17344 3.25227 6.17344 3.71939 6.4836 4.02955C6.79377 4.33972 7.26088 4.33972 7.57105 4.02955L8.26986 3.33075V6.55572C8.26986 6.98174 8.62113 7.33301 9.04714 7.33301C9.47689 7.33301 9.82442 6.98174 9.82442 6.55572Z"
            fill={color}
        />
        <path
            d="M8.27128 11.4438V14.6688L7.56873 13.97C7.25857 13.6598 6.79145 13.6598 6.48128 13.97C6.32433 14.1269 6.05154 14.6314 6.48128 15.0574L8.50297 17.0791C8.81313 17.3893 9.22793 17.4453 9.59042 17.0791L11.6121 15.0574C11.9223 14.7472 11.9223 14.2801 11.6121 13.97C11.3019 13.6598 10.8348 13.6598 10.5247 13.97L9.82584 14.6688V11.4438C9.82584 11.0178 9.47457 10.6665 9.04856 10.6665C8.61881 10.6665 8.27128 11.0178 8.27128 11.4438Z"
            fill={color}
        />
        <rect x="0.666992" y="8.1665" width="16.6667" height="1.66667" rx="0.833333" fill={color} />
    </svg>
)

export default DragIcon
